import {createAction} from 'util/redux'
import {CustomFieldTO} from 'generated/JavaTO'
import {CFModel} from 'module/CustomField/type/CFType'
import {ClipboardValue} from 'module/Clipboard/type/ClipboardTypes'

const NAMESPACE = "CLIPBOARD/";
export const saveToClipboardFromCFModelAction = createAction<{ model: CFModel, cfDefs: CustomFieldTO[] }>(NAMESPACE + 'saveTo');
export const updateClipboardAction = createAction<{ clipboard: string, value: ClipboardValue }>(NAMESPACE + 'update')